<template>
  <div id="container" class="appclick">
    <v-container>
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
        <span class="title">Exit</span>
      </Header>
    </v-container>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
export default {
  components: {
    Header
  }
};
</script>
